import * as React from "react";
import { forwardRef } from "react";
const SvgOrdersNav = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.16667 16.25H17.5M9.16667 10.4167H17.5M9.16667 4.58335H17.5M2.5 4.58335L3.33333 5.41669L5.83333 2.91669M2.5 10.4167L3.33333 11.25L5.83333 8.75002M2.5 16.25L3.33333 17.0834L5.83333 14.5834", stroke: "var(--stroke)", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgOrdersNav);
export default ForwardRef;
